import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Welcome from '../views/home/Welcome.vue'

// 动态导入页面组件
const UserManagement = () => import('../views/home/UserManagement.vue')
const PartnerManagement = () => import('../views/home/PartnerManagement.vue')
const ProposalManagement = () => import('../views/home/ProposalManagement.vue')
const VoteTaskManagement = () => import('../views/home/VoteTaskManagement.vue')
const DelegateManagement = () => import('../views/home/DelegateManagement.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    redirect: '/home/welcome',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'welcome',
        name: 'Welcome',
        component: Welcome,
        meta: { requiresAuth: true }
      },
      {
        path: 'user',
        name: 'UserManagement',
        component: UserManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'partner',
        name: 'PartnerManagement',
        component: PartnerManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'proposal',
        name: 'ProposalManagement',
        component: ProposalManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'vote',
        name: 'VoteTaskManagement',
        component: VoteTaskManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'delegate',
        name: 'DelegateManagement',
        component: DelegateManagement,
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = store.state.token || localStorage.getItem('token')

  // 如果已登录且访问登录页,重定向到首页
  if (token && to.path === '/login') {
    next('/home')
    return
  }

  // 如果访问需要认证的页面但未登录,重定向到登录页
  if (to.meta.requiresAuth && !token) {
    next('/login')
    return
  }

  next()
})

export default router
